export default __webpack_public_path__ + "static/media/Q2_4_resized.e5a88b78.jpg";